<template>
  <div class="container align-self-center">
    <div class="row">
      <div class="col-12">
        <article class="search-container d-none d-md-flex" v-clickaway.detectIframe="hideSearch">
          <GpInputSearch ref="input" :class="{ focusing: show }" :clear="true" @focus="showSearch" v-model="query" @input="delaySearch" :indicating.sync="isLoading" :placeholder="$t('generals.searchSomething')" />
          <transition name="fadeIn">
            <PerfectScrollbar class="search-body" v-if="show">
              <template v-if="query == ''">
                <div class="result-group">
                  <p class="result-group-label typo-button14 typo-medium text-light-low">
                    {{ $t("dashboard.recentPages") }}
                  </p>
                  <div class="result-group-list">
                    <PageItem v-for="(item, ind) in recentPagesList" :item="item" :key="item.type + (item.id || ind)" :disabled="accountExpired" @preview="previewRecent" />
                  </div>
                </div>
              </template>
              <template v-else>
                <!-- View all pages tab -->
                <template v-if="showAll.page && querriedPages && querriedPages.length">
                  <div class="result-group">
                    <p class="result-group-label typo-button14 typo-medium text-light-low clickable" @click.stop="viewLess('page')">
                      <i class="icon icon-arrow-left mr-1"></i>
                      {{ $t("search.back") }}
                    </p>
                    <div class="result-group-list">
                      <PageItem v-for="(item, ind) in querriedPages" :item="item" :key="item.type + (item.id || ind)" :disabled="accountExpired" @preview="previewQuery" />
                    </div>
                  </div>
                </template>
                <!-- Normal tab -->
                <template v-else>
                  <!-- Pages -->
                  <div class="result-group" v-if="querriedPages && querriedPages.length">
                    <p class="result-group-label typo-button14 typo-medium text-light-low">
                      {{ $tc("page.page", 2) }}
                    </p>
                    <div class="result-group-list">
                      <PageItem v-for="(item, ind) in filteredPages" :item="item" :key="item.type + (item.id || ind)" :disabled="accountExpired" @preview="previewFilter" />
                    </div>
                    <template v-if="!showAll.page && querriedPages.length - filteredPages.length > 0">
                      <div class="result-group-more" @click.stop="viewMore('page')">
                        <p class="typo-paragraph12 typo-medium d-inline-flex align-items-center">
                          <span>{{ $t("search.more", { num: querriedPages.length - filteredPages.length }) }}</span>
                          <i class="icon icon-arrow-right ml-1"></i>
                        </p>
                      </div>
                    </template>
                  </div>
                  <!-- Templates -->
                  <div class="result-group" v-if="querriedTemplates && querriedTemplates.length">
                    <p class="result-group-label typo-button14 typo-medium text-light-low">
                      {{ $tc("sidebar.templates", 2) }}
                      <!-- <router-link :to="{ name: 'Templates' }" class="typo-paragraph12 typo-medium text-mono3 ml-auto" @click.native="hideSearch">{{ $t("search.viewTmpl") }}</router-link> -->
                    </p>
                    <div class="result-group-list p-2 pt-0">
                      <div class="row">
                        <TemplateItem class="mt-2" v-for="(item, ind) in querriedTemplates" :item="item" :key="'template_' + (item.id || ind)" @select="previewTemplate" />
                      </div>
                    </div>
                  </div>
                  <!-- Faqs -->
                  <div class="result-group" v-if="querriedFaqs && querriedFaqs.length">
                    <p class="result-group-label typo-button14 typo-medium text-light-low">
                      FAQs
                    </p>
                    <div class="result-group-list">
                      <FaqItem v-for="(item, ind) in querriedFaqs" :item="item" :key="'faq_' + (item.id || ind)" />
                    </div>
                  </div>
                  <!-- In case search not match any item -->
                  <div class="result-empty" v-if="noItemsFound">
                    <div class="result-empty-body">
                      <h4 class="typo-heading20 typo-medium text-dark-high-contrast mb-1">{{ $t("search.noResult", { keyword: query }) }}</h4>
                      <p class="typo-paragraph14 typo-regular text-dark-low-contrast">{{ $t("search.tryAnother") }}</p>
                    </div>
                    <!-- <div class="result-empty-footer">
                      <p class="typo-paragraph12 typo-medium text-light-disabled mb-1">
                        {{ $t("search.youCan") }}
                        <router-link :to="{ name: 'LandingPagesTemplate' }" class="text-primary" @click.native="hideSearch">{{ $t("dashboard.createNewPage") }}</router-link> {{ $t("search.or") }} <router-link :to="{ name: 'Templates' }" class="text-primary" @click.native="hideSearch">{{ $t("search.viewAll") }}</router-link> {{ $t("search.weCrafted") }}
                      </p>
                      <p class="typo-paragraph12 typo-medium text-light-disabled">
                        {{ $t("search.concern") }} <router-link :to="{ name: 'FAQs' }" class="text-primary" @click.native="hideSearch">{{ $t("search.faq") }}</router-link>
                      </p>
                    </div> -->
                  </div>
                </template>
              </template>
            </PerfectScrollbar>
          </transition>
        </article>
      </div>
    </div>

    <!-- Modal Preview Template -->
    <PreviewTemplate v-if="showPreview" :template="template_id" @close="closePreview" @select="selectTemplate" :list="querriedTemplates" :hideEdit="accountExpired" />

    <!-- Modal Preview Pages -->
    <PreviewTemplate v-if="showPreviewPage" :template="page_id" @close="closePreviewPage" :list="selectedPagesList" type="page" :hideEdit="accountExpired" />

    <!-- Modal Create Page -->
    <ModalCreatePage v-if="showModal" :shop="shopInfo.shopifyDomain" :template.sync="template_id" :type.sync="type" @close="closeModal" />
  </div>
</template>

<script>
import { GpInputSearch } from "@/core/shared/GpForms";
import { mapState, mapActions, mapGetters } from "vuex";
import PageItem from "@/core/components/SearchItems/PageItem.vue";
import TemplateItem from "@/core/components/SearchItems/TemplateItem.vue";
import FaqItem from "@/core/components/SearchItems/FaqItem.vue";
import { PreviewTemplate, ModalCreatePage } from "@/modules/Shopify/components";

export default {
  name: "UniversalSearch",
  components: {
    GpInputSearch,
    PageItem,
    TemplateItem,
    FaqItem,
    PreviewTemplate,
    ModalCreatePage
  },
  data() {
    return {
      show: false,
      query: "",
      showModal: false,
      showPreview: false,
      showPreviewPage: false,
      showLoading: false,
      showAll: {
        page: false,
        template: false,
        faq: false
      },
      limit: 5,

      searchRunner: null,
      template_id: null,
      page_id: null,
      listType: null
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    ...mapState("page", {
      recentPages: state => state.pages.recentPage,
      loadingTemplates: state => state.templates.statusList.loading,
      resultPages: state => state.search.pages,
      resultTemplates: state => state.search.templates,
      resultFAQs: state => state.search.faqs
    }),
    ...mapGetters("page", {
      allPages: "allPages",
      getTemplate: "getTemplate",
      allTemplates: "allTemplates",
      loadingPages: "loadingPages"
    }),
    accountExpired() {
      return this.shopInfo.plan == "trial" && this.shopInfo.remainingDays <= 0;
    },
    selectedTemplate() {
      let output = this.getTemplate(this.template_id);

      return output;
    },
    isLoading() {
      return this.loadingPages || this.loadingTemplates;
    },
    recentPagesList() {
      if (!this.recentPages.list || !this.recentPages.list.length) return [];
      let defaultList = ["Theme Index Template", "Your first Homepage", "Theme Product Template", "Theme Collection Template"];
      return this.recentPages.list.filter(item => {
        return !defaultList.includes(item.title);
      });
    },
    querriedPages() {
      let arr = [...this.allPages];
      let q = (this.query || "").toLowerCase();
      return arr.filter(item => {
        const id = item.id + "";
        return (item.title && item.title.toLowerCase().includes(q)) || id.includes(q);
      });
    },
    filteredPages() {
      return this.querriedPages.filter((item, index) => index < this.limit);
    },
    selectedPagesList() {
      if (this.listType == "recent") return this.recentPagesList;
      if (this.listType == "query") return this.querriedPages;
      if (this.listType == "filter") return this.filteredPages;
      return [];
    },
    querriedTemplates() {
      let arr = [...this.allTemplates];
      this.resultTemplates.forEach(item => {
        let ind = arr.findIndex(x => x.id == item.id);
        if (ind > -1) {
          arr.splice(ind, 1);
        }
        arr.unshift(item);
      });
      let q = (this.query || "").toLowerCase();
      return arr
        .filter(item => item.name && item.name.toLowerCase().indexOf(q) > -1)
        .filter((item, index) => {
          if (!this.showAll.template) {
            return index < this.limit;
          }
          return true;
        });
    },
    querriedFaqs() {
      let arr = [...this.resultFAQs];
      let q = (this.query || "").toLowerCase();
      return arr
        .filter(item => item.title && item.title.toLowerCase().indexOf(q) > -1)
        .filter((item, index) => {
          if (!this.showAll.faq) {
            return index < this.limit;
          }
          return true;
        });
    },
    noItemsFound() {
      let join = this.querriedPages.length + this.querriedTemplates.length + this.querriedFaqs.length;

      return join <= 0;
    }
  },
  watch: {},
  created() {
    this.checkAndFetchRecentPages();
  },
  methods: {
    ...mapActions("page", {
      fetchPages: "fetchPages",
      searchAnything: "searchAnything"
    }),
    showSearch() {
      this.show = true;
    },
    hideSearch() {
      this.show = false;
    },
    checkAndFetchRecentPages() {
      if (!this.recentPages || !this.recentPages.fetched) {
        this.fetchPages({ type: "recentPage" });
      }
    },
    viewMore(type) {
      if (this.showAll[type] != true) this.showAll[type] = true;
      this.showSearch();
    },
    viewLess(type) {
      if (this.showAll[type] != false) this.showAll[type] = false;
      this.showSearch();
    },
    search() {
      this.searchAnything(this.query.trim());
    },
    delaySearch() {
      clearTimeout(this.searchRunner);
      this.searchRunner = setTimeout(() => {
        this.search();
      }, 500);
    },
    previewTemplate(item) {
      this.template_id = item.id;
      this.showPreview = true;
    },
    closePreview() {
      this.template_id = null;
      this.showPreview = false;
    },
    previewPage(item) {
      this.page_id = item.id;
      this.showPreviewPage = true;
    },
    closePreviewPage() {
      this.page_id = null;
      this.showPreviewPage = false;
    },
    previewFilter(item) {
      this.listType = "filter";
      this.previewPage(item);
    },
    previewQuery(item) {
      this.listType = "query";
      this.previewPage(item);
    },
    previewRecent(item) {
      this.listType = "recent";
      this.previewPage(item);
    },
    openLoading() {
      this.showLoading = true;
    },
    closeLoading() {
      this.showLoading = false;
    },
    selectTemplate(id) {
      this.template_id = id;
      this.openModal();
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    openBlankModal() {
      this.openModal();
      this.template_id = "0";
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  &-enter-active {
    animation-name: fadeIn;
    animation-duration: 0.2s;
  }

  &-leave-active {
    animation-name: fadeIn;
    animation-duration: 0.2s;
    animation-direction: reverse;
  }
}

.search-container {
  // margin-left: 172px;
  // margin-right: 67px;
  position: relative;
  display: flex;
  align-items: center;
  ::v-deep {
    .gp-input-search {
      &-finder {
        color: $textDarkModeDisabled !important;
      }
      
      &-clear, &-loading {
        color: $neutral5 !important;
      }

      input {
        background: $dark7;
        color: $neutral5;
        border: 1px solid $dark5 !important;

        &:focus {
          border-color: transparent;
        }
        &:hover {
          background: $dark7 !important;
        }
      }

      @include placeholder-color($textDarkModeDisabled);
      @include placeholder {
        @include trans-all;
      }

      &:not(:focus):not(.focusing):hover {
        @include placeholder-color($textDarkModeLowContrast);
        &-finder {
          color: $textDarkModeLowContrast !important;
        }
        input {
          background: $dark8 !important;
        }
      }

      &.focusing {
        input {
          border-color: $mono2 !important;
        }
      }
    }
  }
}

.search-body {
  position: absolute;
  display: flex;
  flex-flow: column;
  top: 108%;
  width: 100%;
  right: 0px;
  z-index: 50;
  transform: translate(0, 0);
  max-height: calc(100vh * 2 / 3);
  border-radius: 3px;
  // overflow: overlay;
  @include shadow-2dp;
}

.result-group {
  &-label {
    display: flex;
    align-items: center;
    height: 32px;
    width: 100%;
    background: $black3;
    color: $textDarkModeHighContrast;
    padding: 7px 16px;
    border-bottom: 1px solid rgba(214, 214, 214, 0.1);
  }

  &-list {
    background: $black2;
    display: flex;
    flex-direction: column;
  }

  &-more {
    position: relative;
    padding: 7px 16px 8px 16px;
    color: $textDarkModeHighContrast;
    background: $black2;
    border-top: 1px solid rgba(214, 214, 214, 0.1);
    cursor: pointer;
    @include trans-all;

    &:hover {
      background: $black3;
    }
  }

  &:first-child &-label {
    border-top-color: transparent;
  }
}

.result-empty {
  background: $black2;
  &-body,
  &-footer {
    @include flex-center;
    flex-direction: column;
  }
  &-body {
    width: 100%;
    padding: calc(88vh / 9) 0 calc(72vh / 9) 0;
  }
  &-footer {
    padding: 16px 0;
    border-top: 1px solid $light3;
  }
}
</style>
